import { PaginatedList } from '@people-science/core';
import { useApiGet } from '../../api/Api.hooks';
import { Room } from '../../models/Room';

export function useGetRoomList() {
  const { data, isLoading, error, get } =
    useApiGet<PaginatedList<Room>>('users/me/rooms');
  return {
    roomList: data,
    loadingRooms: isLoading,
    loadingRoomsError: error,
    getRooms: get
  };
}
